import React, { ReactElement } from 'react';
import './amountOutOfBoundsModal.scss';

interface IAmountOutOfBoundsModalProps {
    lowerBound: number;
    upperBound: number;
    onCloseClick(): void;
}

const AmountOutOfBoundsModal = (props: IAmountOutOfBoundsModalProps): ReactElement => {

    const { lowerBound, upperBound } = props;

    const handleCloseClick = () => {
        props.onCloseClick();
    };

    return (
        <div className="pxl-modal amount-out-of-bounds-modal">
            <div className="pxl-modal__content">
                <h3 className="amount-out-of-bounds-modal__headline">
                    <i className="icon-warning"/>
                    Increases exceed recommendations
                </h3>
                <p className="amount-out-of-bounds-modal__body">
                    Recommendations are limited to {lowerBound}% below and {upperBound}% over.
                    Please re-enter your increase.
                </p>
                <div className="amount-out-of-bounds-modal__footer">
                    <button
                        type="button"
                        onClick={handleCloseClick}
                        className="pxl-btn pxl-btn--primary amount-out-of-bounds-modal__close-btn"
                    >
                        Review Decisions
                    </button>
                </div>
            </div>
        </div>
    );
};

export { AmountOutOfBoundsModal };
export default AmountOutOfBoundsModal;